<template>
  <div id="home" class="company-website">
    <!-- 1. 顶部导航+轮播图板块 -->
    <div class="hero-section" style="height: 100vh">
      <nav :class="{ 'nav-scrolled': isNavScrolled }" class="nav-bar">
        <div class="nav-container">
          <div class="nav-logo">
            <img alt="" src="@/assets/image/logo.png" />
            <img alt="" src="@/assets/image/logo-text.png" />
          </div>
          <div :class="{ 'mobile-open': mobileMenuOpen }" class="nav-menu">
            <div :class="{ active: activeNav === 'home' }" class="nav-item">
              <a href="#home" @click.prevent="scrollToSection('home')">{{ t("index.首页") }}</a>
            </div>
            <div :class="{ active: activeNav === 'product' }" class="nav-item">
              <a href="#product" @click.prevent="checkProduce(0)">{{ t("index.产品") }}</a>
            </div>
            <div :class="{ active: activeNav === 'cert' }" class="nav-item">
              <a href="#cert" @click.prevent="scrollToSection('cert')">{{ t("index.资质认证") }}</a>
            </div>
            <div :class="{ active: activeNav === 'advantage' }" class="nav-item">
              <a href="#advantage" @click.prevent="scrollToSection('advantage')">{{ t("index.解决方案") }}</a>
            </div>
            <div :class="{ active: activeNav === 'partner' }" class="nav-item">
              <a href="#partner" @click.prevent="scrollToSection('partner')">{{ t("index.全球合作伙伴") }}</a>
            </div>
            <div :class="{ active: activeNav === 'contact' }" class="nav-item">
              <a href="#order" @click.prevent="scrollToSection('order')">{{ t("index.联系我们") }}</a>
            </div>
          </div>
          <div class="search-wrapper">
            <div class="search-box">
              <input :value="searchQuery" :placeholder="t('index.搜索产品')" type="text" @input="onSearchInput" />
              <img alt="" src="@/assets/image/search.png" />
            </div>
            <ul v-if="showDropdown && filteredSearchItems.length > 0" class="search-dropdown">
              <li v-for="item in filteredSearchItems" :key="`${item.tag}-${item.id}`" class="search-dropdown-item" @click="selectSearchItem(item)">
                <span>{{ isEnglish ? item.nameEn : item.name }}</span>
                <span>{{ item.tag }}</span>
              </li>
            </ul>
          </div>
          <div v-if="isEnglish" class="nav-login" @click="changeLocal">
            <span>Switch to Chinese</span>
          </div>
          <div v-else class="nav-login" @click="changeLocal">
            <span>切换英文</span>
          </div>
        </div>
      </nav>
      <div class="swiper-container">
        <Swiper
          :autoplay="true"
          :loop="true"
          :modules="modules"
          :navigation="{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          }"
          :pagination="{
            clickable: true,
            el: '.swiper-pagination',
          }"
          class="banner-swiper"
        >
          <!-- 自定义左右箭头 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>

          <!-- 自定义底部指示器容器 -->
          <div class="swiper-pagination"></div>
          <SwiperSlide v-for="(item, index) in swiperPictures" :key="item.id">
            <div class="slide-item">
              <img :src="item.picture" :alt="'轮播图 ' + (index + 1)" />
              <div class="slide-content">
                <h2 v-if="isEnglish ? item.titleEn : item.title" class="slide-main-title">{{ isEnglish ? item.titleEn : item.title }}</h2>
                <p v-if="isEnglish ? item.contentEn : item.content" class="slide-sub-title">{{ isEnglish ? item.contentEn : item.content }}</p>
                <button v-if="(isEnglish ? item.titleEn : item.title) || (isEnglish ? item.contentEn : item.content)" class="slide-btn">
                  {{ t("index.了解更多") }}
                </button>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>

    <!-- 2. 南京禄高公司介绍板块 -->
    <div class="company-intro-nj" style="height: 100vh">
      <div class="intro-container">
        <div class="intro-content">
          <div class="intro-gallery">
            <div class="gallery-top">
              <img v-if="profileData?.pic1" alt="南京公司" :src="profileData.pic1" />
              <div class="factory-btn" @click="checkTeam">
                <span>{{ t("index.查看更多") }}</span>
              </div>
            </div>
            <div class="gallery-bottom">
              <img v-if="profileData?.pic2" alt="南京公司办公环境" :src="profileData.pic2" />
              <img v-if="profileData?.pic3" alt="南京工厂外观" :src="profileData.pic3" />
            </div>
          </div>
          <div class="intro-right">
            <h2 class="section-title">{{ t("index.南京禄高运动器材有限公司") }}</h2>
            <div class="intro-text">
              <p v-if="profileData" v-html="isEnglish ? profileData.textEn : profileData.text"></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 3. 常州禄旺公司介绍板块 -->
    <div class="company-intro-cz" style="height: 100vh">
      <div class="intro-main">
        <img v-if="introData?.picture" alt="常州公司" class="intro-img" :src="introData.picture" />
        <div class="intro-container">
          <div class="intro-content">
            <div class="intro-text">
              <h2 class="section-title">{{ t("index.常州禄旺运动器材有限公司") }}{{ t("index.禄高全资子公司") }}</h2>
              <div v-if="introData" class="intro-p">
                <p>{{ isEnglish ? introData.textEn1 : introData.text1 }}</p>
                <p>{{ isEnglish ? introData.textEn2 : introData.text2 }}</p>
                <p>{{ isEnglish ? introData.textEn3 : introData.text3 }}</p>
              </div>
            </div>
            <div class="company-data">
              <div class="data-item">
                <img alt="" src="@/assets/image/introduction-1.png" />
                <span class="data-num">{{ introData?.num1 }}</span>
                <span class="data-name">{{ t("index.占地面积(㎡)") }}</span>
              </div>
              <div class="data-item">
                <img alt="" src="@/assets/image/introduction-2.png" />
                <span class="data-num">{{ introData?.num2 }}</span>
                <span class="data-name">{{ t("index.年产能") }}</span>
              </div>
              <div class="data-item">
                <img alt="" src="@/assets/image/introduction-3.png" />
                <span class="data-num">{{ introData?.num3 }}</span>
                <span class="data-name">{{ t("index.员工人数") }}</span>
              </div>
              <div class="data-item">
                <img alt="" src="@/assets/image/introduction-4.png" />
                <span class="data-num">{{ introData?.num4 }}</span>
                <span class="data-name">{{ t("index.销售地区") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 4. 产品中心板块 -->
    <ProductComponent></ProductComponent>

    <!-- 5. 热销产品板块 -->
    <div id="hot" class="hot-products" style="height: 100vh">
      <div class="hot-container">
        <h2 class="section-title">{{ t("index.热销产品") }}</h2>
        <div class="hot-list">
          <div v-for="(item, index) in hotProducts" :key="item.id" class="hot-item" @click="checkProduce(index)">
            <div class="hot-img">
              <el-image :alt="item.name" :src="item.picture1" fit="contain" />
            </div>
            <div class="hot-price">
              <h3>{{ isEnglish ? item.nameEn : item.name }}</h3>
              <span>+</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 6. 资质认证板块 -->
    <div
      id="cert"
      class="certifications"
      :style="{ height: '100vh', backgroundImage: certData?.picture ? `url(${encodeUrl(certData.picture)})` : 'none' }"
    >
      <div class="cert-container">
        <div>
          <h2 class="section-title">{{ t("index.资质认证") }}</h2>
          <span class="section-intro">{{ t("index.权威认证 · 品质保障") }}</span>
        </div>
        <div class="cert-content">
          <span v-if="certData" class="cert-intro">{{ isEnglish ? certData.textEn1 : certData.text1 }}</span>
          <div class="cert-bottom">
            <div class="cert-text">
              <div class="cert-item">
                <div class="cert-index">
                  <p>1</p>
                </div>
                <span v-if="certData">{{ isEnglish ? certData.textEn2 : certData.text2 }}</span>
              </div>
              <div class="cert-item">
                <div class="cert-index">
                  <p>2</p>
                </div>
                <span v-if="certData">{{ isEnglish ? certData.textEn3 : certData.text3 }}</span>
              </div>
              <div class="cert-item">
                <div class="cert-index">
                  <p>3</p>
                </div>
                <span v-if="certData">{{ isEnglish ? certData.textEn4 : certData.text4 }}</span>
              </div>
            </div>
            <div class="cert-image">
              <div class="cert-grid-item">
                <img src="@/assets/image/zs1.png" alt="FIBA" />
                <div class="cert-label" @click="handleCertDownload('FIBA')">
                  <p>FIBA</p>
                  <el-icon><Download /></el-icon>
                </div>
              </div>
              <div class="cert-grid-item">
                <img src="@/assets/image/zs2.png" alt="ISO9001" />
                <div class="cert-label" @click="handleCertDownload('ISO9001')">
                  <p>ISO9001</p>
                  <el-icon><Download /></el-icon>
                </div>
              </div>
              <div class="cert-grid-item">
                <img src="@/assets/image/zs3.png" alt="ISO14001" />
                <div class="cert-label" @click="handleCertDownload('ISO14001')">
                  <p>ISO14001</p>
                  <el-icon><Download /></el-icon>
                </div>
              </div>
              <div class="cert-grid-item">
                <img src="@/assets/image/zs4.png" alt="ISO45001" />
                <div class="cert-label" @click="handleCertDownload('ISO45001')">
                  <p>ISO45001</p>
                  <el-icon><Download /></el-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 7. 公司优势板块 -->
    <div
      id="advantage"
      class="company-advantages"
      :style="{ height: '100vh', backgroundImage: advantageData?.picture ? `url(${encodeUrl(advantageData.picture)})` : 'none' }"
    >
      <div class="advantage-container">
        <div>
          <h2 class="section-title">{{ t("index.选择我们的优势") }}</h2>
          <span class="section-intro">{{ t("index.真诚服务 客服至上") }}</span>
        </div>
        <div class="advantage-list">
          <div class="advantage-item">
            <div class="advantage-title">
              <img alt="" src="@/assets/image/advantage-1.png" />
              <h3>{{ t("index.现代化工厂") }}</h3>
            </div>
            <p v-if="advantageData">{{ isEnglish ? advantageData.textEn1 : advantageData.text1 }}</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-title">
              <img alt="" src="@/assets/image/advantage-2.png" />
              <h3>{{ t("index.研发能力卓越") }}</h3>
            </div>
            <p v-if="advantageData">{{ isEnglish ? advantageData.textEn2 : advantageData.text2 }}</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-title">
              <img alt="" src="@/assets/image/advantage-3.png" />
              <h3>{{ t("index.合作经验丰富") }}</h3>
            </div>
            <p v-if="advantageData">{{ isEnglish ? advantageData.textEn3 : advantageData.text3 }}</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-title">
              <img alt="" src="@/assets/image/advantage-4.png" />
              <h3>{{ t("index.一站式服务") }}</h3>
            </div>
            <p v-if="advantageData">{{ isEnglish ? advantageData.textEn4 : advantageData.text4 }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 8. OEM流程板块 -->
    <div id="plan" class="oem-process" :style="{ height: '100vh', backgroundImage: flowData?.pic ? `url(${encodeUrl(flowData.pic)})` : 'none' }">
      <div class="oem-mask" :style="{ background: `rgba(255, 255, 255, ${flowData?.flow ?? 0.5})` }">
        <div class="process-container">
          <div>
            <h2 class="section-title">{{ t("index.专业OEM/ODM流程") }}</h2>
            <span class="section-intro">{{ t("index.服务全球品牌") }}</span>
          </div>
          <div class="process-steps">
            <!-- 第一排：左→右 -->
            <div class="process-row">
              <template v-for="(item, index) in processPictures.slice(0, 4)" :key="item.id">
                <div class="process-step">
                  <img :src="item.picture" alt="流程步骤" />
                  <p>{{ isEnglish ? item.englishText : item.text }}</p>
                </div>
                <div v-if="index < 3" class="process-arrow">
                  <img src="@/assets/image/left-icon.png" alt="箭头" />
                </div>
              </template>
            </div>
            <!-- 第二排：右→左（蛇形回流） -->
            <div class="process-row">
              <template v-for="(item, index) in processPictures.slice(4, 8)" :key="item.id">
                <div class="process-step">
                  <img :src="item.picture" alt="流程步骤" />
                  <p>{{ isEnglish ? item.englishText : item.text }}</p>
                </div>
                <div v-if="index < 3" class="process-arrow arrow-rotated">
                  <img src="@/assets/image/left-icon.png" alt="箭头" />
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 9. 合作伙伴板块 -->
    <div id="partner" class="partners" :style="{ backgroundImage: broData?.pic ? `url(${encodeUrl(broData.pic)})` : 'none' }">
      <div class="partner-container">
        <div>
          <h2 class="section-title">{{ t("index.全球合作伙伴") }}</h2>
          <span class="section-intro">{{ t("index.服务全球品牌") }}</span>
        </div>
        <span v-if="broData" v-html="isEnglish ? broData.textEn : broData.text"></span>
        <div class="app-container">
          <div class="logo-wall">
            <div class="scroll-container top-track">
              <div v-for="(group, index) in groupedImages1" :key="index" class="logo-group">
                <div v-for="(image, i) in group" :key="i" class="logo-item" @click="checkPartner(image.id)">
                  <img :alt="`合作伙伴${index * group.length + i + 1}`" :src="image.url" />
                </div>
              </div>
            </div>

            <div class="scroll-container bottom-track">
              <div v-for="(group, index) in groupedImages2" :key="index" class="logo-group">
                <div v-for="(image, i) in group" :key="i" class="logo-item" @click="checkPartner(image.id)">
                  <img :alt="`合作伙伴${groupedImages1.length * groupedImages1[0].length + index * group.length + i + 1}`" :src="image.url" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 10 订购板块 -->
    <div id="order" class="order-section" :style="{ backgroundImage: `url(${require('@/assets/image/order-bg.png')})` }">
      <div class="order-container">
        <div>
          <h2 class="section-title">{{ t("index.灵活MOQ起订量") }}</h2>
          <span class="section-intro">{{ t("index.适配多元合作需求") }}</span>
        </div>
        <div class="app-container">
          <img :src="isEnglish ? require('@/assets/image/order4.png') : require('@/assets/image/order2.png')" alt="Order" class="order-pic" />
          <img :src="isEnglish ? require('@/assets/image/order3.png') : require('@/assets/image/order1.png')" alt="Order" class="order-pic" />
        </div>
      </div>
    </div>

    <!-- 11. 联系我们板块 -->
    <div id="contact" class="contact-us" style="height: 100vh">
      <div class="contact-container">
        <div>
          <h2 class="section-title">{{ t("index.联系我们") }}</h2>
          <span class="section-intro">{{ t("index.合作咨询、咨询留言") }}</span>
        </div>
        <div class="contact-content">
          <div class="contact-form">
            <h2>{{ t("connect.预约") }}</h2>
            <form @submit.prevent="bookAppointment">
              <el-form :model="formData" label-width="auto">
                <el-form-item>
                  <div class="form-group">
                    <label for="name">{{ t("connect.公司/品牌名称*") }}</label>
                    <input id="name" v-model="formData.name" class="input" placeholder="Full Name *" required type="text" />
                  </div>
                </el-form-item>
                <el-form-item>
                  <div class="form-group">
                    <label for="email">{{ t("connect.邮箱*") }}</label>
                    <input id="email" v-model="formData.email" class="input" placeholder="example@gmail.com" required type="email" />
                  </div>
                </el-form-item>
                <el-form-item>
                  <div class="form-group">
                    <label for="phone" style="font-weight: bold">{{ t("connect.联系电话*") }}</label>
                    <input id="phone" v-model="formData.phone" class="input" placeholder="Contact Number*" required />
                  </div>
                </el-form-item>
                <el-form-item>
                  <div class="form-group">
                    <label for="time" style="font-weight: bold">{{ t("connect.需求建议*") }}</label>
                    <input id="time" v-model="formData.suggest" class="input" placeholder="Requirements/Suggestions*" required />
                  </div>
                </el-form-item>
              </el-form>
              <button type="submit">
                {{ t("connect.提交信息") }}
              </button>
            </form>
          </div>
          <div id="world" class="world">
            <World :displayChinese="!isEnglish"></World>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部信息 -->
    <div class="footer">
      <!-- 目前不需要展示这么多内容 -->
      <div v-if="false" class="footer-main">
        <div class="footer-item">
          <p>Company Info</p>
          <span>About Us</span>
          <span>Carrier</span>
          <span>We are hiring</span>
          <span>Blog</span>
        </div>
        <div class="footer-item">
          <p>Legal</p>
          <span>About Us</span>
          <span>Carrier</span>
          <span>We are hiring</span>
          <span>Blog</span>
        </div>
        <div class="footer-item">
          <p>Features</p>
          <span>Business Marketing</span>
          <span>User Analytic</span>
          <span>Live Chat</span>
          <span>Unlimited Support</span>
        </div>
        <div class="footer-item">
          <p>Resources</p>
          <span>IOS & Android</span>
          <span>Watch a Demo</span>
          <span>Customers</span>
          <span>API</span>
        </div>
        <div class="footer-item last-item">
          <p>Get In Touch</p>
          <div class="footer-contact">
            <img alt="" src="@/assets/image/icon-4.png" />
            <span>(86-025-56213098</span>
          </div>
          <div class="footer-contact">
            <img alt="" src="@/assets/image/icon-5.png" />
            <span>江苏省南京市溧⽔区永阳街道涌泉路89号天安</span>
          </div>
          <div class="footer-contact">
            <img alt="" src="@/assets/image/icon-6.png" />
            <span>brook@lg-sport.com</span>
          </div>
        </div>
      </div>
      <div class="footer-contact-main">
        <div class="footer-contact">
          <img alt="" src="@/assets/image/icon-4.png" />
          <span>86-025-56213098</span>
        </div>
        <div class="footer-contact">
          <img alt="" src="@/assets/image/icon-5.png" />
          <span>{{ t("footer.江苏省南京市溧水区永阳街道涌泉路89号天安数码城A5栋12楼1201室") }}</span>
        </div>
        <div class="footer-contact">
          <img alt="" src="@/assets/image/icon-6.png" />
          <div style="text-align: left">
            <p>brook@lg-sport.com</p>
            <p>kay@lg-sport.com</p>
            <p>sales01@lg-sport.com</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 版权 -->
    <div class="copyright">
      <div class="copyright-main">
        <div class="copyright-text">
          <span>© 2025 LG-sports. All rights reserved</span>
          <p>{{ t("index.备案号:") }} <a href="https://beian.miit.gov.cn/">苏ICP备2023012397号-2</a></p>
        </div>
        <div class="platform">
          <el-popover>
            <template #reference>
              <img alt="" src="@/assets/image/icon-9.png" />
            </template>
            <template #default>
              <div v-if="imgOptions && imgOptions[2].picture" class="platform-list">
                <img
                  v-for="(item, index) in imgOptions[2].picture.split(',')"
                  :key="index"
                  :src="item"
                  alt=""
                  style="width: 100%; object-fit: cover"
                />
              </div>
            </template>
          </el-popover>
          <el-popover>
            <template #reference>
              <img alt="" src="@/assets/image/icon-9.png" />
            </template>
            <template #default>
              <div v-if="imgOptions && imgOptions[3].picture" class="platform-list">
                <img
                  v-for="(item, index) in imgOptions[3].picture.split(',')"
                  :key="index"
                  :src="item"
                  alt=""
                  style="width: 100%; object-fit: cover"
                />
              </div>
            </template>
          </el-popover>
          <el-popover>
            <template #reference>
              <img alt="" src="@/assets/image/icon-9.png" />
            </template>
            <template #default>
              <div v-if="imgOptions && imgOptions[4].picture" class="platform-list">
                <img
                  v-for="(item, index) in imgOptions[4].picture.split(',')"
                  :key="index"
                  :src="item"
                  alt=""
                  style="width: 100%; object-fit: cover"
                />
              </div>
            </template>
          </el-popover>
        </div>
      </div>
    </div>
    <!-- 回到顶部 -->
    <el-backtop :bottom="100" :right="100" :visibility-height="500" />
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent, nextTick, onActivated, onBeforeUnmount, onMounted, ref } from "vue"
import { Swiper, SwiperSlide } from "swiper/vue"
import { Navigation, Pagination } from "swiper/modules"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import ProductComponent from "@/components/ProductComponent.vue"
import { partnerImagesGroup1, partnerImagesGroup2 } from "@/data/partners"
import { useRouter } from "vue-router"
import {
  addContact,
  getAdvantageInfo,
  getBroInfo,
  getCertificatePdfByName,
  getCertificationInfo,
  getFlowPicture,
  getImgOptions,
  getIntroductionInfo,
  getProcessPictures,
  getProductData,
  getProductList,
  getProfileInfo,
  getSwiperPictures,
  getType,
} from "@/api/index"
import { setToken } from "@/utils/auth"
import { ElMessage } from "element-plus"
import { Download } from "@element-plus/icons-vue"
import i18n from "@/locale"
import { useI18n } from "vue-i18n"

const World = defineAsyncComponent(() => import("@/components/WorldMap.vue"))

const router = useRouter()
const modules = [Navigation, Pagination]
const imgArr1 = partnerImagesGroup1
const imgArr2 = partnerImagesGroup2
const { t } = useI18n()

const groupedImages1 = computed(() => [imgArr1, imgArr1])
const groupedImages2 = computed(() => [imgArr2, imgArr2])

const isEnglish = computed(() => i18n.global.locale.value === "en")
const searchQuery = ref("")
const showDropdown = ref(false)
const typeList = ref([])
const productSearchResults = ref([])
let searchRequestId = 0
let debounceTimer = null
const filteredSearchItems = computed(() => {
  const query = searchQuery.value.toLowerCase().trim()
  if (!query) return []
  const localTag = isEnglish.value ? "Category" : "分类"
  const productTag = isEnglish.value ? "Product" : "产品"
  const localMatches = typeList.value
    .filter((item) => (item.name || "").toLowerCase().includes(query) || (item.nameEn || "").toLowerCase().includes(query))
    .map((item) => ({
      ...item,
      tag: localTag,
    }))
  const apiMatches = productSearchResults.value.map((item) => ({
    ...item,
    tag: productTag,
  }))
  return [...localMatches, ...apiMatches]
})
const onSearchInput = (e) => {
  const value = e?.target?.value ?? ""
  searchQuery.value = value
  clearTimeout(debounceTimer)
  productSearchResults.value = []
  if (!value.trim()) {
    showDropdown.value = false
    return
  }
  debounceTimer = setTimeout(async () => {
    const query = value.trim()
    const requestId = ++searchRequestId
    try {
      const res = await getProductData({ name: query, page: 1, size: 999 })
      if (requestId === searchRequestId) {
        if (res.code === 200 && res.commodityList) {
          productSearchResults.value = res.commodityList.list || []
        }
      }
    } catch (e) {
      if (requestId === searchRequestId) {
        productSearchResults.value = []
      }
    }
    if (requestId === searchRequestId) {
      showDropdown.value = filteredSearchItems.value.length > 0
    }
  }, 300)
}
const selectSearchItem = (item) => {
  console.log("Selected item:", item)
  searchQuery.value = isEnglish.value ? item.nameEn : item.name
  showDropdown.value = false
  const isCategory = item.tag === "分类" || item.tag === "Category"
  const isProduct = item.tag === "产品" || item.tag === "Product"
  if (isCategory) {
    // 分类：跳转到 goods 页面，index 为该分类在 typeList 中的位置
    const idx = typeList.value.findIndex((t) => t.id === item.id)
    if (idx !== -1) {
      router.push(`/goods?index=${idx}`)
    }
  } else if (isProduct) {
    // 产品：跳转到 goods 页面，定位到该产品的具体位置
    const typeIdx = typeList.value.findIndex((t) => t.id === item.typeId)
    if (typeIdx !== -1) {
      router.push(`/goods?index=${typeIdx}&childId=${item.childTypeId}&productId=${item.id}`)
    }
  }
}
const formData = ref({
  name: "",
  email: "",
  phone: "",
  suggest: "",
})
const activeNav = ref("home")
const ticking = ref(false)
const isNavScrolled = ref(false)
const mobileMenuOpen = ref(false)
const isMobile = ref(false)
const processPictures = ref([])
const swiperPictures = ref([])
const imgOptions = ref(null)
const hotProducts = ref([])
const introData = ref(null)
const advantageData = ref(null)
const certData = ref(null)
const profileData = ref(null)
const broData = ref(null)
const flowData = ref(null)

const encodeUrl = (url) => {
  if (!url) return ""
  return encodeURI(url).replace(/\s/g, "%20")
}
const checkPartner = (id) => {
  router.push("/brand/" + id)
}
const validateForm = () => {
  if (formData.value.name.trim() === "") {
    ElMessage.error(t("message.请输入公司姓名"))
    return false
  }
  if (formData.value.suggest.trim() === "") {
    ElMessage.error(t("message.请输入您的建议"))
    return false
  }
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  if (!emailRegex.test(formData.value.email)) {
    ElMessage.error(t("message.请输入正确的邮箱格式"))
    return false
  }
  const phoneRegex = /^(\+?\d{1,3}[-.\s]?)?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/
  if (!phoneRegex.test(formData.value.phone)) {
    ElMessage.error(t("message.请输入正确的联系电话"))
    return false
  }
  return true
}
const bookAppointment = () => {
  if (!validateForm()) return
  const data = {
    name: formData.value.name,
    email: formData.value.email,
    phone: formData.value.phone,
    text: formData.value.suggest,
  }
  addContact(data).then((res) => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t("message.数据获取失败"))
    ElMessage.success(i18n.global.t("message.操作成功"))
    formData.value = {
      name: "",
      email: "",
      phone: "",
      suggest: "",
    }
  })
}
const handleScroll = () => {
  if (!ticking.value) {
    requestAnimationFrame(() => {
      isNavScrolled.value = window.scrollY > 100
      ticking.value = false

      const navMapping = { hot: "product", plan: "advantage", order: "contact" }
      const sections = ["home", "product", "hot", "advantage", "plan", "partner", "cert", "order", "contact"]
      const currentSection = sections.findLast((section) => {
        const element = document.getElementById(section)
        if (element) {
          const rect = element.getBoundingClientRect()
          if (section === "home") {
            return rect.top <= 100 && (rect.bottom >= 100 || window.scrollY < 100)
          }
          return rect.top <= 100 && rect.bottom >= 100
        }
        return false
      })

      if (currentSection) {
        activeNav.value = navMapping[currentSection] || currentSection
      }
    })
    ticking.value = true
  }
}
const scrollToSection = (sectionId) => {
  // 小屏幕下先关闭下拉菜单
  if (mobileMenuOpen.value) {
    mobileMenuOpen.value = false
    const navMenu = document.querySelector(".nav-bar .nav-menu")
    if (navMenu) navMenu.classList.remove("mobile-open")
  }
  const element = document.getElementById(sectionId)
  if (element) {
    window.scrollTo({
      top: element.offsetTop,
      behavior: "smooth",
    })
    const navMapping = { order: "contact" }
    activeNav.value = navMapping[sectionId] || sectionId
  }
}
const changeLocal = () => {
  i18n.global.locale.value = i18n.global.locale.value === "zh-Hans" ? "en" : "zh-Hans"
  setToken("language", i18n.global.locale.value)
}
const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
  const navMenu = document.querySelector(".nav-bar .nav-menu")
  if (mobileMenuOpen.value) {
    navMenu.classList.add("mobile-open")
  } else {
    navMenu.classList.remove("mobile-open")
  }
}
const checkScreenSize = () => {
  isMobile.value = window.innerWidth <= 767
}
const addBtn = () => {
  if (!isMobile.value) return
  if (document.querySelector(".hamburger-menu")) return
  const navMain = document.querySelector(".nav-bar .nav-container")
  if (navMain) {
    const hamburger = document.createElement("div")
    hamburger.className = "hamburger-menu"
    hamburger.innerHTML = "☰"
    hamburger.style.cssText = `
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 24px;
      cursor: pointer;
      color: #333;
      z-index: 31;
    `
    hamburger.addEventListener("click", toggleMobileMenu)
    navMain.appendChild(hamburger)
  }
}
const removeBtn = () => {
  const existingBtn = document.querySelector(".hamburger-menu")
  if (existingBtn) {
    existingBtn.remove()
  }
}
const handleResize = () => {
  checkScreenSize()
  if (isMobile.value) {
    nextTick(() => {
      addBtn()
    })
  } else {
    mobileMenuOpen.value = false
    removeBtn()
  }
}
const checkTeam = () => {
  router.push("/team")
}
const checkProduce = (index) => {
  router.push("/goods?index=" + index)
}
const getSwiperImg = async () => {
  const res = await getSwiperPictures()
  if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t("message.数据获取失败"))
  swiperPictures.value = res.data
}
const getOptions = () => {
  getImgOptions().then((res) => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t("message.数据获取失败"))
    imgOptions.value = res.footPictureInfoList
  })
}
const getHotProducts = () => {
  getProductList().then((res) => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t("message.数据获取失败"))
    const list = (res.data || []).slice(0, 4).map((item) => ({
      ...item,
      picture1: typeof item.picture === "string" ? item.picture.split(",")[0] : Array.isArray(item.picture) ? item.picture[0] : item.picture,
    }))
    hotProducts.value = list
  })
}
const getProcessData = () => {
  getProcessPictures().then((res) => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t("message.数据获取失败"))
    processPictures.value = res.data || []
  })
}
const getIntroData = () => {
  getIntroductionInfo().then((res) => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t("message.数据获取失败"))
    introData.value = res.data
  })
}
const getAdvantageData = () => {
  getAdvantageInfo().then((res) => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t("message.数据获取失败"))
    advantageData.value = res.data
  })
}
const getCertData = () => {
  getCertificationInfo().then((res) => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t("message.数据获取失败"))
    certData.value = res.data
  })
}
const handleCertDownload = async (name) => {
  try {
    const res = await getCertificatePdfByName(name)
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t("message.数据获取失败"))
    if (res.data && res.data.file) {
      window.open(res.data.file, "_blank")
    }
  } catch (err) {
    ElMessage.error(err.message || i18n.global.t("message.数据获取失败"))
  }
}
const getProfileData = () => {
  getProfileInfo().then((res) => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t("message.数据获取失败"))
    profileData.value = res.data
  })
}
const getBroData = () => {
  getBroInfo().then((res) => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t("message.数据获取失败"))
    broData.value = res.data
  })
}
const getFlowData = () => {
  getFlowPicture().then((res) => {
    if (res.code !== 200) return ElMessage.error((isEnglish.value ? res.msgEn : res.msg) || i18n.global.t("message.数据获取失败"))
    flowData.value = res.data
  })
}
const handleClickOutside = (e) => {
  const wrapper = document.querySelector(".search-wrapper")
  if (wrapper && !wrapper.contains(e.target)) {
    showDropdown.value = false
  }
}
const fetchAllTypes = async () => {
  try {
    const res = await getType()
    if (res.code === 200) {
      typeList.value = res.typeInfoList || []
    }
  } catch (e) {
    // type list fetch is non-critical
  }
}
onMounted(() => {
  checkScreenSize()
  fetchAllTypes()
  getSwiperImg()
  getOptions()
  getHotProducts()
  getProcessData()
  getIntroData()
  getAdvantageData()
  getCertData()
  getProfileData()
  getBroData()
  getFlowData()
  isNavScrolled.value = window.scrollY > 100
  window.addEventListener("scroll", handleScroll)
  window.addEventListener("resize", handleResize)
  document.addEventListener("click", handleClickOutside)
  if (isMobile.value) {
    addBtn()
  }

  const navMapping = { hot: "product", plan: "advantage", order: "contact" }
  const sections = ["home", "product", "hot", "advantage", "plan", "partner", "cert", "order", "contact"]
  const currentSection = sections.findLast((section) => {
    const element = document.getElementById(section)
    if (element) {
      const rect = element.getBoundingClientRect()
      // 对于首页做特殊处理
      if (section === "home") {
        return rect.top <= 100 && (rect.bottom >= 100 || window.scrollY < 100)
      }
      return rect.top <= 100 && rect.bottom >= 100
    }
    return false
  })

  if (currentSection) {
    activeNav.value = navMapping[currentSection] || currentSection
  } else {
    activeNav.value = "home"
  }

  // 处理 URL hash 初始滚动（如 /#partner）
  if (window.location.hash) {
    const sectionId = window.location.hash.substring(1)
    nextTick(() => {
      setTimeout(() => {
        const el = document.getElementById(sectionId)
        if (el) {
          window.scrollTo({ top: el.offsetTop, behavior: "smooth" })
          const navMapping = { order: "contact" }
          activeNav.value = navMapping[sectionId] || sectionId
        }
      }, 400)
    })
  }
})
// keep-alive 缓存后重新激活时处理 hash 滚动
onActivated(() => {
  // 缓存恢复时关闭可能处于展开状态的移动端菜单
  if (mobileMenuOpen.value) {
    mobileMenuOpen.value = false
    const navMenu = document.querySelector(".nav-bar .nav-menu")
    if (navMenu) navMenu.classList.remove("mobile-open")
  }
  if (window.location.hash) {
    const sectionId = window.location.hash.substring(1)
    nextTick(() => {
      setTimeout(() => {
        const el = document.getElementById(sectionId)
        if (el) {
          window.scrollTo({ top: el.offsetTop, behavior: "smooth" })
          const navMapping = { order: "contact" }
          activeNav.value = navMapping[sectionId] || sectionId
        }
      }, 400)
    })
  }
})
onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll)
  window.removeEventListener("resize", handleResize)
  document.removeEventListener("click", handleClickOutside)
  removeBtn()
})
</script>

<style lang="scss" scoped>
// 全局样式重置
.company-website {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft Yahei", sans-serif;
  color: #333;
  overflow-x: hidden;

  // 通用板块标题样式
  .section-title {
    font-size: 40px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 50px;
    padding-top: 30px;
    color: #2c3e50;
  }

  // 1. 轮播图+导航板块
  .hero-section {
    width: 100%;
    position: relative;
    overflow: hidden;

    .nav-bar {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 999;
      background: rgba(255, 255, 255, 0.9);
      padding: 0 50px;
      height: 80px;
      line-height: 80px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

      .nav-container {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 20px;
        height: 100%;

        .nav-logo {
          width: 40px;
          display: flex;
          flex-direction: column;
          align-items: center;

          img {
            width: 100%;
          }
        }

        .nav-menu {
          flex: 1;
          display: flex;
          list-style: none;
          justify-content: center;
          align-items: center;
          gap: 30px;

          .nav-item {
            // padding: 10px 15px;

            &:hover {
              a {
                color: var(--new-btnColor);
                transform: scale(1.2);
              }
            }

            a {
              text-decoration: none;
              color: #333;
              font-size: 16px;
              transition: all 0.5s;
              display: inline-block;
              transform-origin: center center;
              line-height: 1.4;
              text-align: center;
            }
          }

          .active {
            a {
              color: var(--new-btnColor);
              transform: scale(1.2);
            }
          }
        }

        .search-wrapper {
          position: relative;
        }

        .search-box {
          border-radius: 24px;
          border: 1px solid;
          display: flex;
          padding: 10px;
          box-sizing: border-box;
          gap: 20px;

          input {
            flex: 1;
            outline: none;
            border: none;
            background: transparent;
          }

          img {
            width: 20px;
            height: 20px;
          }
        }

        .search-dropdown {
          position: absolute;
          top: 145%;
          left: 0;
          right: 0;
          background: #fff;
          border-top: none;
          border-radius: 0 0 8px 8px;
          padding: 0;
          list-style: none;
          z-index: 1000;
          max-height: 240px;
          overflow-y: auto;

          .search-dropdown-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 16px;
            cursor: pointer;
            transition: background 0.2s;
            border-bottom: 1px solid #f0f0f0;
            line-height: 1.5;

            &:last-child {
              border-bottom: none;
              border-radius: 0 0 8px 8px;
            }

            &:hover {
              background: #f5f5f5;
            }

            span:first-child {
              font-size: 14px;
              color: #333;
            }

            span:last-child {
              font-size: 12px;
              color: #999;
            }
          }
        }

        .nav-login {
          width: 160px;
          text-align: center;

          &:hover {
            cursor: pointer;
          }

          span {
            font-weight: bold;
            color: #333;
            font-size: 16px;
            transition: all 0.5s;
            line-height: 1.4;

            &:hover {
              color: var(--new-btnColor);
            }
          }
        }
      }
    }

    .swiper-container {
      height: calc(100vh - 80px);
      margin-top: 80px;

      .banner-swiper {
        height: 100%;

        .slide-item {
          position: relative;
          width: 100%;
          height: 100%;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .slide-content {
            position: absolute;
            top: 50%;
            left: 10%;
            transform: translateY(-50%);
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            text-align: left;
            color: #fff;
            max-width: 600px;
            z-index: 10;

            .slide-main-title {
              font-size: 56px;
              font-weight: 700;
              margin: 0;
              line-height: 1.2;
              text-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
            }

            .slide-sub-title {
              font-size: 24px;
              margin-top: 40px;
              margin-bottom: 40px;
              font-weight: 400;
              opacity: 0.9;
              text-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
            }

            .slide-btn {
              padding: 12px 36px;
              font-size: 18px;
              font-weight: 600;
              color: #fff;
              background: #007bff;
              border: none;
              border-radius: 24px;
              cursor: pointer;
              transition: all 0.3s ease;
              box-shadow: 0 4px 15px rgba(0, 123, 255, 0.4);

              &:hover {
                background: #0056b3;
                transform: translateY(-2px);
                box-shadow: 0 6px 20px rgba(0, 123, 255, 0.6);
              }
            }
          }
        }
      }
    }
  }

  // 2. 南京公司介绍板块
  .company-intro-nj {
    display: flex;
    align-items: center;
    justify-content: center;

    .intro-container {
      width: 80%;
      height: 80%;
      display: flex;
      align-items: center;
      position: relative;

      .intro-content {
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        gap: 80px;

        .intro-gallery {
          grid-column: 1 / 3;
          grid-row: 1 / 3;
          display: flex;
          flex-direction: column;
          gap: 80px;

          .gallery-top {
            flex: 1;
            display: flex;
            align-items: flex-start;
            gap: 35px;
            overflow: hidden;
            border-radius: 24px;
            min-height: 0;

            img {
              width: 72%;
              height: 100%;
              object-fit: cover;
              object-position: center;
              border-radius: 24px;
              min-width: 0;
            }

            .factory-btn {
              flex-shrink: 0;
              align-self: flex-end;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              padding: 10px 20px;
              border-radius: 36px;
              border: 1px solid #333;
              cursor: pointer;
              transition: all 0.5s;
              width: fit-content;
              height: fit-content;
              white-space: nowrap;
              background: rgba(255, 255, 255, 0.85);

              span {
                text-align: center;
              }

              &:hover {
                border: 1px solid var(--new-btnColor);
                background: var(--new-btnColor);
                color: #fff;
                transform: scale(1.1);
              }
            }
          }

          .gallery-bottom {
            flex: 1;
            display: flex;
            gap: 80px;
            min-height: 0;

            img {
              flex: 1;
              height: 100%;
              object-fit: cover;
              border-radius: 24px;
              min-width: 0;
            }
          }
        }

        .intro-right {
          grid-column: 3;
          grid-row: 1 / 3;
          height: 100%;
          display: flex;
          flex-direction: column;
          overflow: hidden;

          .section-title {
            position: absolute;
            top: 0;
            right: 0;
            text-align: right;
            font-size: 40px;
            margin: 0;
            padding-top: 0;
            padding-bottom: 20px;
            flex-shrink: 0;

            &::before {
              content: "";
              width: 30px;
              background: #00aeef;
              height: 2px;
              display: block;
              position: absolute;
              bottom: 0;
              right: 0;
            }
          }

          .intro-text {
            flex: 1;
            font-size: 18px;
            line-height: 2;
            color: #555;
            overflow-y: auto;
            min-height: 0;
            margin-top: 180px;
          }
        }
      }
    }
  }

  // 3. 常州公司介绍板块
  .company-intro-cz {
    background: #ebebeb;
    display: flex;
    align-items: center;
    width: 100%;

    .intro-main {
      width: 80%;
      display: flex;
      flex-direction: column;
      gap: 40px;
      margin: 0 auto;
      height: 100%;
      box-sizing: border-box;

      .intro-img {
        width: 100%;
        border-radius: 24px;
        height: 40%;
        object-fit: cover;
      }

      .intro-container {
        width: 100%;
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;

        .section-title {
          width: 100%;
          display: block;
          text-align: left;
          margin: 0;
          padding-bottom: 20px;
          position: relative;
          flex-shrink: 0;

          &::before {
            content: "";
            width: 30px;
            background: #00aeef;
            height: 2px;
            display: block;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }

        .intro-content {
          display: flex;
          gap: 50px;
          flex: 1;
          min-height: 0;

          .intro-text {
            width: 60%;
            min-height: 0;
            display: flex;
            flex-direction: column;

            .intro-p {
              min-height: 0;
              overflow-y: auto;
              width: 100%;
              margin-top: 15px;
              display: flex;
              flex-direction: column;
              gap: 8px;

              p {
                font-size: 15px;
                line-height: 1.7;
                color: #555;
              }
            }
          }

          .company-data {
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            padding: 8px;
            align-self: flex-start;
            justify-content: center;

            .data-item {
              text-align: center;
              background: #fff;
              border-radius: 0.5rem;
              aspect-ratio: 1 / 1;
              width: 40%;
              max-width: 220px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              gap: 15px;
              box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

              img {
                width: 30px;
                height: 30px;
              }

              .data-num {
                display: block;
                font-size: 36px;
                font-weight: 700;
                color: #333;
              }

              .data-name {
                font-size: 16px;
                color: #333;
              }
            }
          }
        }
      }
    }
  }

  // 5. 热销产品板块
  .hot-products {
    background: linear-gradient(to bottom, #8af0ff, #ffffff);
    display: flex;
    align-items: center;

    .hot-container {
      width: 80%;
      height: 80%;
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .section-title {
        width: 100%;
        display: block;
        text-align: left;
        margin: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #333333;
      }

      .hot-list {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 60px;

        .hot-item {
          width: 100%;
          margin: auto;
          transition: transform 0.3s ease;

          &:nth-child(odd) {
            transform: translateY(-30px);
          }

          &:nth-child(even) {
            transform: translateY(30px);
          }

          .hot-img {
            width: 100%;
            margin-bottom: 30px;
            padding: 100px 0;
            position: relative;
            z-index: 2;
            display: flex;

            &::before {
              content: "";
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              transform: skew(-5deg);
              transform-origin: center;
              background: #fff;
              z-index: 1;
            }

            :deep(.el-image) {
              width: 100%;
              border-radius: 50%;
              height: 100%;
              position: relative;
              z-index: 3;
              max-height: 260px;
              max-width: 260px;
              aspect-ratio: 1 / 1;
              margin: auto;
            }
            :deep(.el-image__inner) {
              object-fit: cover;
            }
          }

          .hot-price {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            transform: translateX(-18px);
          }

          h3 {
            font-size: 20px;
            color: #333;
            position: relative;

            &::before {
              content: "";
              width: 40px;
              background: #00aeef;
              height: 2px;
              display: block;
              position: absolute;
              bottom: -10px;
              left: 0;
            }
          }

          span {
            display: block;
            width: 30px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            background: #8af0ff;
            flex-shrink: 0;
            cursor: pointer;
          }
        }
      }
    }
  }

  // 6. 公司优势板块
  .company-advantages {
    width: 100%;
    display: flex;
    align-items: center;
    background: url("https://picsum.photos/500/300?random=30") center center;
    background-size: cover;

    .advantage-container {
      width: 80%;
      height: 80%;
      margin: auto;
      display: flex;
      flex-direction: column;
      gap: 30px;

      .section-title {
        width: 100%;
        display: block;
        text-align: left;
        margin: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #fff;
        color: #ffffff;
      }

      .section-intro {
        color: #ffffff;
        margin-top: 20px;
        display: block;
      }

      .advantage-list {
        flex: 1;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 25px;
        overflow: hidden;

        .advantage-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          background: rgba(255, 255, 255, 0.8);
          padding: 25px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          clip-path: polygon(0 0, calc(100% - 50px) 0, 100% 50px, 100% 100%, 0 100%);

          .advantage-title {
            width: 100%;
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 15px;
            flex-shrink: 0;

            img {
              width: 40px;
              height: 40px;
            }
          }

          h3 {
            font-size: 20px;
            color: #333;
            margin-bottom: 0;
          }

          p {
            flex: 1;
            overflow-y: auto;
            font-size: 14px;
            line-height: 1.8;
            color: #666;
            margin-bottom: 0;
            padding-right: 5px;
          }
        }
      }
    }
  }

  // 7. OEM流程板块
  .oem-process {
    width: 100%;
    display: flex;
    align-items: center;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;

    .oem-mask {
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.5);
      display: flex;
    }

    .process-container {
      width: 80%;
      height: 80%;
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      gap: 60px;

      .section-title {
        width: 100%;
        display: block;
        text-align: left;
        margin: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #000;
        color: #000;
      }

      .section-intro {
        color: #000;
        margin-top: 20px;
        display: block;
      }

      .process-steps {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
        position: relative;

        // 胶囊形边框
        &::before {
          content: "";
          width: 100%;
          height: 50%;
          position: absolute;
          top: 54%;
          left: 50%;
          transform: translate(-50%, -58%);
          border: 1px solid #999;
          border-radius: 48px;
          z-index: 1;
        }

        // 两排之间的90°旋转箭头，定位在胶囊形边框右侧
        &::after {
          content: "";
          position: absolute;
          top: 46%;
          right: 0;
          width: 36px;
          height: 36px;
          background-image: url("@/assets/image/left-icon.png");
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          transform: translate(18px, -50%) rotate(90deg);
          z-index: 3;
        }

        .process-row {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: clamp(5px, calc(5vw - 60px), 50px);
          width: 100%;
          position: relative;
          z-index: 2;

          .process-step {
            text-align: center;
            flex: 1;
            max-width: 230px;

            img {
              width: 200px;
              height: 200px;
              background: #fff;
              padding: 5px;
              border-radius: 50%;
              margin-bottom: 10px;
              object-fit: cover;
              box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            }

            p {
              font-size: 16px;
              color: #555;
              font-weight: 500;
              width: 100%;
              text-align: center;
            }
          }

          .process-arrow {
            flex-shrink: 0;
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }

            &.arrow-rotated {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
  }

  // 8. 合作伙伴板块
  .partners {
    width: 100%;
    height: 100vh;
    align-items: center;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;

    .partner-container {
      width: 80%;
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      gap: 60px;

      .section-title {
        width: 100%;
        display: block;
        text-align: left;
        margin: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #fff;
        color: #fff;
      }

      .section-intro {
        color: #fff;
        margin-top: 20px;
        display: block;
      }

      span {
        color: #fff;
      }

      .app-container {
        width: 100%;
        margin: 0 auto;
        overflow-x: hidden;
      }

      .logo-wall {
        width: 100%;
        overflow: hidden;
        position: relative;
        padding: 20px 0;

        &::before,
        &::after {
          content: "";
          position: absolute;
          top: 0;
          height: 100%;
          width: 100px;
          z-index: 10;
          pointer-events: none;
        }

        &::before {
          left: 0;
          //background: linear-gradient(to right, transparent 70%, transparent 100%);
        }

        &::after {
          right: 0;
          //background: linear-gradient(to left, transparent 70%, transparent 100%);
        }

        .scroll-container {
          display: flex;
          align-items: center;
          width: 200%;

          &.top-track {
            animation: scroll-right 20s linear infinite;
          }

          &.bottom-track {
            animation: scroll-left 20s linear infinite;
            margin-top: 20px;
          }

          &:hover {
            animation-play-state: paused;
            cursor: pointer;
          }

          .logo-group {
            display: flex;
            justify-content: space-around;
            width: 100%;
            gap: 20px;
            margin-right: 20px;

            .logo-item {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 80px;
              width: 160px;
              padding: 10px;
              background-color: white;
              border-radius: 8px;
              box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
              transition: all 0.3s ease;
              flex-shrink: 0;

              &:hover {
                transform: translateY(-5px);
                box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
              }

              img {
                max-height: 100%;
                max-width: 100%;
                object-fit: contain;
              }
            }
          }
        }
      }

      @keyframes scroll-right {
        from {
          transform: translateX(0);
        }
        to {
          transform: translateX(-50%);
        }
      }

      @keyframes scroll-left {
        from {
          transform: translateX(-50%);
        }
        to {
          transform: translateX(0);
        }
      }
    }
  }

  // 合作伙伴板块 - 手机端
  @media (max-width: 767px) {
    .partners {
      height: auto;

      .partner-container {
        width: 90%;
      }
    }
  }

  // 9. 资质认证板块
  .certifications {
    width: 100%;
    align-items: center;
    background: url("https://picsum.photos/500/300?random=64") center center no-repeat;
    background-size: cover;
    display: flex;

    .cert-container {
      width: 80%;
      height: 85%;
      margin: auto;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .section-title {
        width: 100%;
        display: block;
        text-align: left;
        margin: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #fff;
        color: #fff;
      }

      .section-intro {
        color: #fff;
        margin-top: 20px;
        display: block;
      }

      .cert-content {
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 20px;

        .cert-intro {
          flex-shrink: 0;
          display: block;
          line-height: 1.6;
          width: 80%;
          color: #fff;
        }

        .cert-bottom {
          flex: 1;
          display: flex;
          gap: 40px;
          overflow: hidden;

          .cert-text {
            flex: 1;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            gap: 20px;

            .cert-item {
              flex-shrink: 0;
              width: 100%;
              background: #fff;
              border-radius: 24px;
              padding: 20px 30px;
              display: flex;
              gap: 40px;
              align-items: center;

              .cert-index {
                padding: 10px;
                position: relative;

                &::before {
                  content: "";
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  background: #00deff;
                  transform: skew(-10deg);
                  z-index: 1;
                  top: 0;
                  left: 0;
                }

                p {
                  font-size: 36px;
                  font-weight: bold;
                  color: #000;
                  z-index: 2;
                  position: relative;
                }
              }

              span {
                line-height: 1.5;
              }
            }
          }

          .cert-image {
            flex-shrink: 0;
            display: grid;
            grid-template-columns: 1fr 1fr;
            width: 42%;
            max-width: 420px;
            gap: 24px;

            .cert-grid-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              gap: 12px;

              img {
                width: 100%;
                aspect-ratio: 1 / 1;
                object-fit: contain;
              }

              .cert-label {
                display: flex;
                align-items: center;
                gap: 6px;
                cursor: pointer;

                p {
                  font-size: 16px;
                  font-weight: 600;
                  color: #fff;
                  margin: 0;
                }

                .el-icon {
                  font-size: 16px;
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }

  // 9.5 订购板块
  .order-section {
    width: 100%;
    height: 100vh;
    align-items: center;
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 100% 40vh;
    display: flex;

    .order-container {
      width: 80%;
      height: 80%;
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      gap: 60px;

      .section-title {
        width: 100%;
        display: block;
        text-align: left;
        margin: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #000;
        color: #000;
      }

      .section-intro {
        color: #000;
        margin-top: 20px;
        display: block;
      }

      .app-container {
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
        align-items: center;
        gap: 40px;

        .order-pic {
          max-width: 40%;
          height: auto;
          object-fit: contain;
        }
      }
    }
  }

  // 10. 联系我们板块
  .contact-us {
    width: 100%;
    background: #e1e1e1;
    display: flex;
    align-items: center;

    .contact-container {
      width: 80%;
      height: 80%;
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 30px;
      overflow: hidden;

      .section-title {
        width: 100%;
        display: block;
        text-align: left;
        margin: 0;
        padding-bottom: 20px;
        border-bottom: 1px solid #000;
        color: #000;
        flex-shrink: 0;
      }

      .section-intro {
        color: #000;
        margin-top: 20px;
        display: block;
      }

      .contact-content {
        width: 100%;
        flex: 1;
        min-height: 0;
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        overflow: hidden;

        .contact-form {
          width: 40%;
          max-height: 100%;
          padding: 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          background: #fff;
          border-radius: 12px;

          h2 {
            text-align: center;
            margin-bottom: 20px;
            font-size: 24px;
          }

          form {
            display: flex;
            flex-direction: column;

            .form-group {
              width: 100%;

              label {
                display: block;
                font-weight: bold;
                font-size: 15px;
                text-align: left;
              }

              input,
              select {
                width: 100%;
                padding: 10px;
                border: 1px solid #ccc;
                border-radius: 4px;
              }
            }

            button {
              width: 100%;
              padding: 15px 0;
              border-radius: 36px;
              text-align: center;
              border: 1px solid #ccc;
              transition: all 0.5s;
              cursor: pointer;
              background: transparent;
              margin-top: 10px;

              &:hover {
                border: 1px solid var(--new-btnColor);
                background: var(--new-btnColor);
                transform: scale(1.1);
                color: #fff;
              }
            }
          }

          .input {
            background-color: #f8f8f8;
            border: 2px solid transparent;
            width: 100%;
            padding-left: 0.8em;
            outline: none;
            overflow: hidden;
            border-radius: 10px;
            transition: all 0.5s;
          }

          .input:hover,
          .input:focus {
            border: 1px solid #fff;
            box-shadow: 0 0 0 7px rgb(74, 157, 236, 20%);
            background-color: white;
          }

          :deep(.el-select) {
            width: 100%;

            .el-select__wrapper {
              background-color: white;
            }

            &.is-focus .el-select__wrapper,
            &:not(.is-empty) .el-select__wrapper {
              background-color: #f8f8f8;
            }
          }
        }

        .world {
          width: 55%;
        }
      }
    }
  }

  // 底部信息
  .footer {
    width: 100%;
    background: var(--new-bgColor2);
    padding: 10px 0;
    font-weight: lighter;
    font-size: 14px;

    .footer-main {
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: center;

      .footer-item {
        width: 15%;
        color: #fff;
        font-weight: bold;

        p {
          font-size: 20px;
        }

        span {
          display: block;
          margin: 20px 0;
          font-size: 14px;

          &:hover {
            cursor: pointer;
          }
        }
      }

      .last-item {
        width: 25%;

        p {
          margin-bottom: 20px;
        }

        .footer-contact {
          width: 100%;
          display: flex;
          align-items: center;

          img {
            width: 30px;
            height: 30px;
            display: block;
            margin-right: 20px;
          }

          span {
            margin: 10px 0;
          }
        }
      }
    }

    .footer-contact-main {
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: center;

      .footer-contact {
        width: 100%;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;

        img {
          width: 30px;
          height: 30px;
          display: block;
          margin-right: 20px;
        }

        span,
        p {
          margin: 10px 0;
          color: #fff;
        }
      }
    }
  }

  // 版权
  .copyright {
    width: 100%;
    background: var(--new-bgColor2);
    padding: 10px 0;
    font-weight: lighter;
    font-size: 14px;

    .copyright-main {
      width: 70%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 40px;

      .copyright-text {
        display: flex;
        color: #fff;
        align-items: center;

        p {
          line-height: 0;
          margin-left: 20px;

          a {
            color: #fff;
          }
        }
      }

      .platform {
        display: flex;
        align-items: center;
        gap: 20px;

        img {
          width: 30px;
          height: 30px;
        }

        :deep(.platform-list) {
          img {
            width: 100%;
          }
        }
      }
    }
  }
}

// ==================== 响应式适配 ====================

// ==================== 顶部导航栏 ====================

// 中屏 (992px - 1299px)：缩小间距和字体，适配窄屏
@media (max-width: 1299px) and (min-width: 992px) {
  .company-website .hero-section .nav-bar {
    padding: 0 20px;

    .nav-container {
      width: 100%;
      gap: 10px;

      .nav-logo {
        width: 32px;
        flex-shrink: 0;
      }

      .nav-menu {
        gap: 8px;

        .nav-item {
          padding: 6px 8px;

          a {
            font-size: 14px;
          }
        }
      }

      .search-box {
        padding: 6px 10px;
        gap: 8px;
        border-radius: 20px;

        input {
          width: 100px;
          font-size: 13px;
        }

        img {
          width: 16px;
          height: 16px;
        }
      }

      .nav-login {
        width: auto;
        flex-shrink: 0;

        span {
          font-size: 13px;
          white-space: nowrap;
        }
      }
    }
  }
}

// 平板 (768px - 991px)：进一步缩小，保持水平排列
@media (max-width: 991px) and (min-width: 768px) {
  .company-website .hero-section .nav-bar {
    padding: 0 12px;
    height: 60px;
    line-height: 60px;

    .nav-container {
      width: 100%;
      gap: 6px;

      .nav-logo {
        width: 28px;
        flex-shrink: 0;
      }

      .nav-menu {
        gap: 2px;

        .nav-item {
          padding: 4px 5px;

          a {
            font-size: 12px;
          }
        }
      }

      .search-box {
        padding: 4px 8px;
        gap: 4px;
        border-radius: 16px;

        input {
          width: 70px;
          font-size: 11px;
        }

        img {
          width: 14px;
          height: 14px;
        }
      }

      .nav-login {
        width: auto;
        flex-shrink: 0;

        span {
          font-size: 11px;
          white-space: nowrap;
        }
      }
    }
  }

  // 调整 swiper 高度配合较矮的导航栏
  .company-website .hero-section .swiper-container {
    height: calc(100vh - 60px);
    margin-top: 60px;
  }
}

// 手机 (<768px)：汉堡菜单模式
@media (max-width: 767px) {
  .company-website .hero-section {
    height: auto !important;
  }

  .company-website .hero-section .nav-bar {
    padding: 0 12px;
    height: 56px;
    line-height: 56px;

    .nav-container {
      width: 100%;
      gap: 8px;
      position: relative;
      justify-content: flex-start;

      .nav-logo {
        width: 26px;
        flex-shrink: 0;

        img {
          width: 100%;
          height: auto;
        }
      }

      .nav-menu {
        position: fixed;
        top: 56px;
        left: 0;
        right: 0;
        background: #fff;
        flex-direction: column;
        height: auto;
        padding: 10px 0;
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
        z-index: 32;
        display: flex;
        width: 100%;
        opacity: 0;
        transform: translateY(-100%);
        transition: transform 0.3s ease, opacity 0.3s ease;
        pointer-events: none;

        &.mobile-open {
          opacity: 1;
          transform: translateY(0);
          pointer-events: auto;
        }

        .nav-item {
          width: 100%;
          text-align: left;
          margin: 5px 0;
          height: auto;
          padding: 0 20px;

          a {
            line-height: 40px;
            color: #333;
            display: block;
            text-decoration: none;
            transition: all 0.3s ease;
            font-size: 15px;

            &:hover {
              transform: none;
            }
          }
        }

        .active {
          a {
            color: var(--new-btnColor);
            transform: none !important;
            font-weight: bold;
          }
        }
      }

      .search-wrapper {
        margin-left: auto;
      }

      .search-box {
        display: flex;
        padding: 4px 8px;
        gap: 4px;
        border-radius: 14px;
        flex-shrink: 0;

        input {
          width: 80px;
          font-size: 11px;
        }

        img {
          width: 14px;
          height: 14px;
        }
      }

      .search-dropdown {
        left: auto;
        right: 0;
        min-width: 200px;
      }

      .nav-login {
        width: auto;
        flex-shrink: 0;
        font-size: 11px;
        margin-right: 36px;
        z-index: 30;

        span {
          font-size: 11px;
          white-space: nowrap;
          margin-right: 0;
        }
      }
    }

    // 滚动后导航栏样式
    &.nav-scrolled {
      background: #fff;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);

      .nav-container .nav-menu {
        background: #fff;
      }
    }
  }

  // 汉堡菜单图标（JS动态创建的后备CSS方案）
  .company-website .hero-section .nav-bar .nav-container {
    .hamburger-menu {
      display: block;
    }
  }

  // 导航栏 - 小手机端 (≤480px)
  @media (max-width: 480px) {
    .company-website .hero-section .nav-bar {
      .nav-container {
        .nav-logo {
          width: 24px;
        }

        .nav-info {
          top: 56px;

          .nav-item a {
            padding: 0 15px;
          }
        }

        .search-box {
          padding: 3px 6px;
          gap: 3px;
          border-radius: 12px;

          input {
            width: 60px;
            font-size: 10px;
          }

          img {
            width: 12px;
            height: 12px;
          }
        }

        .search-dropdown {
          min-width: 180px;
        }

        .nav-login {
          margin-right: 46px;

          span {
            font-size: 10px;
          }
        }
      }
    }
  }

  .company-website .hero-section .swiper-container {
    height: calc(50vh - 3.75rem);
    margin-top: 56px;

    .banner-swiper .slide-item .slide-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      flex-direction: column;
      text-align: center;
      color: #fff;
      z-index: 10;
      justify-content: center;
      align-items: center;
      width: 90%;
      max-width: 100%;

      .slide-main-title {
        font-size: 24px;
      }

      .slide-sub-title {
        font-size: 14px;
        margin-top: 16px;
        margin-bottom: 16px;
      }

      .slide-btn {
        font-size: 14px;
        padding: 8px 24px;
      }
    }
  }
}

// 第三部分：常州禄旺公司介绍板块

// 大屏 (≥1300px)：放大文本
@media (min-width: 1300px) {
  .company-website .company-intro-cz {
    .intro-main {
      height: 80%;
      padding: 0;
    }

    .intro-container .intro-content .intro-text .intro-p p {
      font-size: 17px;
      line-height: 2;
    }
  }
}

// 中屏 (992px - 1299px)：缩小数据板块，减少间距
@media (max-width: 1299px) and (min-width: 992px) {
  .company-website .company-intro-cz {
    .intro-main {
      height: 80%;
      gap: 30px;

      .intro-img {
        height: 35%;
      }
    }

    .intro-container .intro-content {
      gap: 30px;

      .company-data {
        gap: 12px;
        padding: 6px;

        .data-item {
          width: 45%;
          gap: 10px;
          padding: 12px 8px;

          img {
            width: 22px;
            height: 22px;
          }

          .data-num {
            font-size: 26px;
          }

          .data-name {
            font-size: 13px;
          }
        }
      }
    }
  }
}

// 平板 (768px - 991px)：上图下字，左右结构变上下结构
@media (max-width: 991px) and (min-width: 768px) {
  .company-website .company-intro-cz {
    height: auto !important;
    min-height: 100vh;

    .intro-main {
      width: 90%;
      padding: 30px 0;
      gap: 30px;

      .intro-img {
        height: 35%;
        border-radius: 16px;
      }

      .intro-container {
        overflow: visible;

        .section-title {
          font-size: 28px;
          padding-bottom: 15px;
          margin-bottom: 30px;
        }

        .intro-content {
          flex-direction: column;
          gap: 40px;
          overflow: visible;

          .intro-text {
            width: 100%;
            overflow-y: visible;

            .intro-p {
              overflow-y: visible;
              flex: none;
              width: 100%;

              p {
                font-size: 15px;
                line-height: 1.8;
              }
            }
          }

          .company-data {
            flex-shrink: 0;
            width: 100%;
            justify-content: space-between;
            gap: 15px;

            .data-item {
              flex: 0 0 calc(25% - 12px);
              aspect-ratio: 1 / 1;
              padding: 20px 10px;

              .data-num {
                font-size: 28px;
              }

              .data-name {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
}

// 手机 (<768px)
@media (max-width: 767px) {
  .company-website .company-intro-cz {
    height: auto !important;
    min-height: 100vh;

    .intro-main {
      width: 92%;
      padding: 20px 0;
      gap: 20px;

      .intro-img {
        height: 25%;
        border-radius: 12px;
      }

      .intro-container {
        overflow: visible;

        .section-title {
          font-size: 22px;
          padding-bottom: 12px;
          margin-bottom: 20px;
        }

        .intro-content {
          flex-direction: column;
          gap: 25px;
          overflow: visible;

          .intro-text {
            width: 100%;
            overflow-y: visible;

            .intro-p {
              overflow-y: visible;
              flex: none;
              width: 100%;

              p {
                font-size: 14px;
                line-height: 1.7;
              }
            }
          }

          .company-data {
            flex-shrink: 0;
            width: 100%;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;

            .data-item {
              width: 100%;
              flex: none;
              aspect-ratio: auto;
              padding: 16px 10px;
              gap: 10px;
              margin: 0 auto;

              img {
                width: 24px;
                height: 24px;
              }

              .data-num {
                font-size: 26px;
              }

              .data-name {
                font-size: 13px;
              }
            }
          }
        }
      }
    }
  }
}

// ==================== 第二部分：南京禄高公司介绍板块 大屏 ====================

// 大屏 (≥1350px)：放大标题字体
@media (min-width: 1350px) {
  .company-website .company-intro-nj {
    .intro-container .intro-content .intro-right .section-title {
      font-size: 50px;
    }
  }
}

// 平板 (768px - 991px)：缩小标题字体
@media (max-width: 991px) and (min-width: 768px) {
  .company-website .company-intro-nj {
    .intro-container .intro-content .intro-right .section-title {
      font-size: 30px;
    }
  }
}

// ==================== 第二部分：南京禄高公司介绍板块 手机端 ====================

// 手机 (<768px)：标题在上，图片在中间，文本在底部，取消高度限制和滚动条
@media (max-width: 767px) {
  .company-website .company-intro-nj {
    height: auto !important;
    padding: 40px 0;

    .intro-container {
      width: 92%;
      height: auto;

      .intro-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        height: auto;
        gap: 15px;
        overflow: visible;

        .intro-gallery {
          grid-column: auto;
          grid-row: auto;
          width: 100%;
          height: auto;
          gap: 30px;

          .gallery-top {
            flex: auto;
            display: flex;
            align-items: flex-start;
            position: static;
            overflow: visible;
            border-radius: 0;
            min-height: auto;
            gap: 30px;

            img {
              flex: 1;
              width: auto;
              height: auto;
              max-height: 200px;
              border-radius: 24px;
            }

            .factory-btn {
              position: static;
              margin: 0;
              flex-shrink: 0;
              margin-top: auto;
              background: transparent;
            }
          }

          .gallery-bottom {
            flex: auto;
            gap: 45px;
            min-height: auto;

            img {
              width: calc(50% - 22.5px);
              height: auto;
              flex: none;
              min-width: auto;
            }
          }
        }

        .intro-right {
          grid-column: auto;
          grid-row: auto;
          width: 100%;
          height: auto;
          gap: 15px;
          overflow: visible;

          .section-title {
            position: relative;
            text-align: center;
            font-size: 22px;
            padding-top: 0;
            padding-bottom: 12px;

            &::before {
              right: 50%;
              transform: translateX(50%);
            }
          }

          .intro-text {
            width: 100%;
            height: auto;
            overflow-y: visible;
            flex: none;
            font-size: 14px;
            line-height: 1.7;
            margin-top: 10px;
          }
        }
      }
    }
  }
}

// ==================== 第五部分：热销产品板块 ====================

// 平板 (768px - 991px)
@media (max-width: 991px) and (min-width: 768px) {
  .company-website .hot-products {
    height: auto !important;
    padding: 40px 0;

    .hot-container {
      width: 80%;

      .section-title {
        margin-bottom: 40px;
      }

      .hot-list {
        grid-template-columns: repeat(2, 1fr);
        gap: 40px;

        .hot-item {
          width: 80%;
          margin: 0 auto;

          &:nth-child(odd),
          &:nth-child(even) {
            transform: none;
          }

          .hot-img {
            padding: 80px 0;
            margin-bottom: 20px;

            :deep(.el-image) {
              max-height: 200px;
              max-width: 200px;
            }
          }

          h3 {
            font-size: 18px;
          }
        }
      }
    }
  }
}

// 手机 (<768px)：一行展示一个
@media (max-width: 767px) {
  .company-website .hot-products {
    height: auto !important;
    padding: 40px 0;

    .hot-container {
      width: 85%;

      .section-title {
        font-size: 22px;
        margin-bottom: 30px;
      }

      .hot-list {
        grid-template-columns: repeat(1, 1fr);
        gap: 30px;

        .hot-item {
          width: 100%;
          margin: 0 auto;

          &:nth-child(odd),
          &:nth-child(even) {
            transform: none;
          }

          .hot-img {
            padding: 60px 0;
            margin-bottom: 15px;

            &::before {
              transform: skew(-3deg);
            }

            :deep(.el-image) {
              max-height: 220px;
              max-width: 220px;
            }
          }

          .hot-price {
            transform: none;
            justify-content: center;
            gap: 20px;
          }

          h3 {
            font-size: 18px;
          }
        }
      }
    }
  }
}

// ==================== 第六部分：公司优势板块 ====================

// 平板 (768px - 991px)：一行一个，高度自适应
@media (max-width: 991px) and (min-width: 768px) {
  .company-website .company-advantages {
    height: auto !important;
    min-height: 100vh;

    .advantage-container {
      width: 85%;
      height: auto;
      padding-bottom: 30px;

      .advantage-list {
        grid-template-columns: 1fr;
        gap: 20px;
        overflow: visible;

        .advantage-item {
          overflow: visible;

          p {
            overflow-y: visible;
            flex: none;
          }
        }
      }
    }
  }
}

// 手机 (<768px)：一行一个，取消滚动条
@media (max-width: 767px) {
  .company-website .company-advantages {
    height: auto !important;
    min-height: 100vh;
    padding: 0;

    .advantage-container {
      width: 90%;
      height: auto;
      padding-bottom: 30px;

      .section-title {
        font-size: 22px;
      }

      .section-intro {
        font-size: 14px;
      }

      .advantage-list {
        grid-template-columns: 1fr;
        gap: 18px;
        overflow: visible;

        .advantage-item {
          overflow: visible;
          clip-path: polygon(0 0, calc(100% - 30px) 0, 100% 30px, 100% 100%, 0 100%);
          padding: 18px;

          h3 {
            font-size: 17px;
          }

          p {
            overflow-y: visible;
            flex: none;
            font-size: 13px;
            line-height: 1.7;
          }
        }
      }
    }
  }
}

// ==================== 第七部分：OEM流程板块 ====================

// 平板 (768px - 991px)：保持一行四个，整体缩小
@media (max-width: 991px) and (min-width: 768px) {
  .company-website .oem-process {
    height: auto !important;
    min-height: 100vh;

    .oem-mask {
      width: 92%;
      margin: auto;
      height: auto;
      padding: 40px;
      border-radius: 16px;
    }

    .process-container {
      width: 100%;
      gap: 35px;

      .section-title {
        font-size: 28px;
      }

      .process-steps {
        gap: 4px;

        &::before {
          height: 50%;
          transform: translate(-50%, -58%);
          border-radius: 36px;
        }

        &::after {
          width: 28px;
          height: 28px;
          transform: translate(14px, -50%) rotate(90deg);
        }

        .process-row {
          gap: 4px;

          .process-step {
            max-width: 160px;

            img {
              width: 140px;
              height: 140px;
            }

            p {
              font-size: 14px;
            }
          }

          .process-arrow {
            width: 28px;
            height: 28px;
          }
        }
      }
    }
  }
}

// ==================== 第七部分续：OEM流程板块 手机端 ====================

// 手机 (<768px)：单列纵向排列
@media (max-width: 767px) {
  .company-website .oem-process {
    height: auto !important;
    min-height: 100vh;

    .oem-mask {
      width: 100%;
      padding: 30px 15px;
      border-radius: 0;
    }

    .process-container {
      width: 100%;
      gap: 25px;

      .section-title {
        font-size: 20px;
      }

      .section-intro {
        font-size: 13px;
      }

      .process-steps {
        max-width: 420px;
        margin: 0 auto;
        gap: 0;

        // 竖线串联所有步骤（替代桌面端胶囊边框）
        &::before {
          width: 2px;
          height: calc(100% - 80px);
          top: 60px;
          left: 50%;
          transform: translateX(-50%);
          border: none;
          background: #ccc;
          border-radius: 1px;
        }

        // 隐藏桌面端右侧90°箭头
        &::after {
          display: none;
        }

        .process-row {
          flex-direction: column;
          align-items: center;
          gap: 0;

          // 第二排蛇形回流：小屏幕下反转顺序（8→7→6→5）
          &:last-child {
            flex-direction: column-reverse;
          }

          // 第一排末尾补一个向下箭头（连接两排之间的缺口）
          &:first-child::after {
            content: "";
            display: block;
            width: 32px;
            height: 32px;
            background-image: url("@/assets/image/left-icon.png");
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            transform: rotate(90deg);
            margin: 6px auto;
            position: relative;
            z-index: 2;
          }

          .process-step {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 10px;
            padding: 12px 0;
            flex: none;
            max-width: 100%;
            text-align: center;
            width: 100%;

            img {
              width: 160px;
              height: 160px;
              flex-shrink: 0;
              margin-bottom: 4px;
            }

            p {
              font-size: 15px;
              text-align: center;
            }
          }

          .process-arrow {
            transform: rotate(90deg);
            margin: 6px auto;
            width: 32px;
            height: 32px;

            &.arrow-rotated {
              // 手机端全部向下，统一旋转90°
              transform: rotate(90deg);
            }
          }
        }
      }
    }
  }
}

// ==================== 第九部分：资质认证板块 ====================

// 平板 (768px - 991px)：高度自适应
@media (max-width: 991px) and (min-width: 768px) {
  .company-website .certifications {
    height: auto !important;
    min-height: 100vh;

    .cert-container {
      width: 85%;
      height: auto;
      padding: 40px 0;

      .cert-content {
        width: 100%;
        overflow: visible;

        .cert-intro {
          overflow-y: visible;
          max-height: none;
          margin: 10px 0;
          line-height: 1.6;
          width: 80%;
        }

        .cert-bottom {
          overflow: visible;
          gap: 20px;

          .cert-text {
            overflow-y: visible;
            flex: 0 0 55%;
            gap: 15px;

            .cert-item {
              padding: 15px 20px;
              gap: 20px;

              .cert-index p {
                font-size: 28px;
              }

              span {
                font-size: 14px;
                line-height: 1.5;
              }
            }
          }

          .cert-image {
            width: 40%;
            max-width: 340px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 15px;

            .cert-grid-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              gap: 8px;

              img {
                width: 100%;
                aspect-ratio: 1 / 1;
                object-fit: contain;
              }

              .cert-label {
                display: flex;
                align-items: center;
                gap: 5px;
                cursor: pointer;

                p {
                  font-size: 18px;
                  font-weight: 600;
                  color: #fff;
                  margin: 0;
                }

                .el-icon {
                  font-size: 18px;
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }
}

// 手机 (<768px)
@media (max-width: 767px) {
  .company-website .certifications {
    height: auto !important;

    .cert-container {
      width: 92%;
      height: auto;
      padding: 30px 0;

      .section-title {
        font-size: 22px;
      }

      .cert-content {
        width: 100%;
        overflow: visible;

        .cert-intro {
          overflow-y: visible;
          max-height: none;
          margin: 20px 0;
          font-size: 14px;
          width: 100%;
        }

        .cert-bottom {
          flex-direction: column;
          gap: 20px;
          overflow: visible;

          .cert-text {
            overflow-y: visible;
            width: 100%;
            gap: 15px;
            flex: none;

            .cert-item {
              padding: 15px 20px;
              gap: 20px;

              .cert-index p {
                font-size: 28px;
              }

              span {
                font-size: 14px;
              }
            }
          }

          .cert-image {
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 12px;

            .cert-grid-item {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              gap: 6px;

              img {
                width: 100%;
                aspect-ratio: 1 / 1;
                object-fit: contain;
              }

              .cert-label {
                display: flex;
                align-items: center;
                gap: 4px;
                cursor: pointer;

                p {
                  font-size: 16px;
                  font-weight: 600;
                  color: #fff;
                  margin: 0;
                }

                .el-icon {
                  font-size: 16px;
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
  }

  .company-website .order-section {
    height: auto;
    background-size: 100% 30vh;

    .order-container {
      width: 90%;
      height: auto;
      gap: 30px;
      padding: 40px 0;

      .app-container {
        flex-direction: column;
        gap: 20px;

        .order-pic {
          max-width: 100%;
          width: 100%;
          height: auto;
        }
      }
    }
  }
}

// ==================== 第十部分：订购板块 - 平板 ====================

@media (max-width: 991px) and (min-width: 768px) {
  .company-website .order-section {
    height: 100vh;
    background-size: 100% 35vh;

    .order-container {
      width: 85%;
      gap: 40px;
      padding: 40px 0;

      .app-container {
        gap: 30px;

        .order-pic {
          max-width: 48%;
        }
      }
    }
  }
}

// ==================== 第十一部分：联系我们板块 ====================

// 平板 (768px - 991px)：上下结构，高度自适应
@media (max-width: 991px) and (min-width: 768px) {
  .company-website .contact-us {
    height: auto !important;
    min-height: 100vh;
    padding: 40px 30px;

    .contact-container {
      width: 85%;
      height: auto;
      overflow: visible;

      .contact-content {
        flex: none;
        flex-direction: column;
        gap: 30px;

        .contact-form {
          width: 100%;
          height: auto;
          max-height: none;
        }

        .world {
          width: 100%;
        }
      }
    }
  }
}

// 手机 (<768px)：上下结构，取消高度限制
@media (max-width: 767px) {
  .company-website .contact-us {
    height: auto !important;
    min-height: 100vh;
    padding: 30px 15px;

    .contact-container {
      width: 92%;
      height: auto;
      overflow: visible;
      gap: 30px;

      .section-title {
        font-size: 22px;
      }

      .section-intro {
        font-size: 13px;
      }

      .contact-content {
        flex: none;
        flex-direction: column;
        gap: 25px;

        .contact-form {
          width: 100%;
          height: auto;
          max-height: none;
          padding: 25px 18px;

          h2 {
            font-size: 20px;
          }
        }

        .world {
          width: 100%;
        }
      }
    }
  }
}

// ==================== 底部信息 + 版权 手机端 ====================

// 手机 (<768px)：联系信息纵向排列
@media (max-width: 767px) {
  .company-website .footer {
    padding: 20px 0;
    font-size: 13px;

    .footer-contact-main {
      width: 90%;
      flex-direction: column;
      gap: 15px;

      .footer-contact {
        justify-content: flex-start;
        text-align: left;
        gap: 10px;

        img {
          width: 22px;
          height: 22px;
          margin-right: 0;
          flex-shrink: 0;
        }

        span {
          font-size: 13px;
          margin: 0;
        }

        p {
          font-size: 13px;
          margin: 3px 0;
        }
      }
    }
  }

  .company-website .copyright {
    font-size: 12px;

    .copyright-main {
      width: 90%;
      flex-direction: column;
      gap: 12px;

      .copyright-text {
        flex-direction: column;
        align-items: center;
        text-align: center;

        p {
          line-height: 1.5;
          margin-left: 0;
          margin-top: 4px;
        }
      }

      .platform {
        gap: 14px;

        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}

// 手机端回到顶部按钮减小距离
@media (max-width: 767px) {
  :deep(.el-backtop) {
    bottom: 20px !important;
    right: 20px !important;
  }
}
</style>
